import { Injectable } from '@angular/core';
import { Globals } from '../../globals/globals';
import { Router } from '@angular/router';
declare var webkitSpeechRecognition: any;

@Injectable({
  providedIn: 'root'
})

export class TeiasoftSpeechRecognitionService {
  /* RECOGNITION */
  recognition =  new webkitSpeechRecognition();
  //isStoppedSpeechRecog = false;
  speechRecognitionStarted: boolean = false;

  /* SPEAK */
  synth = window.speechSynthesis;
  voices:any[] = [];
  speakingIntervalId: any;


  constructor(private globals: Globals, private router:Router) { 

  }

  /************************************** SPEECH RECOGNITION **************************************************/
  /*                                                                                                          */
  /*                                                                                                          */
  /************************************************************************************************************/
  init() {
    console.log(">>> SpeechRecognition: INIT");
    this.recognition.interimResults = true;
    this.recognition.lang = ['it-IT', 'en-US'];
    this.populateVoiceList();
    this.recognition.addEventListener("result", (e:any) => {
      const transcript = Array.from(e.results)
        .map((results) => {
          let _ret: any;
          _ret = <SpeechRecognitionResult>results;
          if (!_ret.isFinal){
            console.log(">>> SpeechRecognition: LISTENING...");
          } else {
            console.log(">>> Hai detto '" + _ret[0].transcript.toLocaleLowerCase() + "' - Confidence: " + _ret[0].confidence);
            this.globals.teiasoftSpeechRecognition!.setPhraseCommand(_ret[0].transcript.toLocaleLowerCase());
          }
        }).join('');
    });
  }

  startListening() {
    this.globals.teiasoftSpeechRecognition!.imListening = true;
    this.globals.teiasoftSpeechRecognition!.imSpeaking = false;
    if (this.speakingIntervalId != undefined) clearInterval(this.speakingIntervalId);
    this.recognition.start();
    this.speechRecognitionStarted = true;
    console.log(">>> SpeechRecognition: STARTED");
    this.recognition.onspeechend(() => {
      console.log(">>> SpeechRecognition: END");
      this.stopListening();
      this.recognition.start();
    });

    /* this.recognition.addEventListener('end', (condition:any) => {
      console.log(">>> SpeechRecognition: END");
      this.stopListening();
      this.recognition.start();
      if (this.speechRecognitionStarted) {
        this.stopListening();
      } else {
        this.recognition.start();
      }
    }); */
  }

  stopListening() {
    this.speechRecognitionStarted = false;
    this.recognition.stop();
    console.log(">>> SpeechRecognition: STOPPED");
  }

  /***************************************** VOICE SYNTHESIS **************************************************/
  /*                                                                                                          */
  /*                                                                                                          */
  /************************************************************************************************************/
  playPhrase(phrase:string){
    this.globals.teiasoftSpeechRecognition!.imListening = false;
    this.globals.teiasoftSpeechRecognition!.imSpeaking = true;
    this.stopListening();
    let utterance = new SpeechSynthesisUtterance(phrase);
    let _voice:any = this.voices.filter(x => x.lang == 'it-IT')[0];
    if (_voice == undefined) _voice = this.voices[0];
    utterance.voice = _voice;
    utterance.volume = 80;
    utterance.pitch = 1;
    utterance.rate = 1.2;
    speechSynthesis.speak(utterance);
    this.speakingIntervalId = setInterval(() => {
      if (!speechSynthesis.speaking){
        if (!this.speechRecognitionStarted) 
          this.startListening();
        else
          clearInterval(this.speakingIntervalId);
      }
    });
  }

  populateVoiceList() {
    speechSynthesis.cancel();
    this.voices = new Array();
    this.voices = this.synth.getVoices();
  }
}
